import React, { useMemo } from 'react';
import BEMHelper from '@ynap/bem-helper';
import ReactMarkdown from 'markdown-to-jsx';
import { useContactUs } from '@ynap/contact-us-hook';

const bem = new BEMHelper('CallUsCTA');

const CallUsCTA = ({ messages, selectedProduct, setUser, trackingCallUs }) => {
    const { freeContactNumber = '', isEip = false } = useContactUs({ selectedProduct, setUser }) || {};
    const call = isEip ? '' : freeContactNumber;
    const message = messages.callUsCTA?.generic({ number: call, formattedNumber: encodeURI(call) });

    return useMemo(
        () =>
            call &&
            message && (
                <div className={bem()}>
                    <ReactMarkdown
                        className={bem('messages')}
                        options={{
                            wrapper: 'div',
                            forceWrapper: true,
                            overrides: {
                                em: ({ ...props }) => (
                                    <>
                                        <br /> <span>{props.children}</span>
                                    </>
                                ),
                                // eslint-disable-next-line no-unused-vars
                                a: ({ node, ...props }) => <a {...props} onClick={trackingCallUs} />,
                            },
                        }}
                    >
                        {message}
                    </ReactMarkdown>
                </div>
            ),
        [freeContactNumber, isEip],
    );
};

export default CallUsCTA;
